import React, {useState, useRef, useEffect} from 'react';

import {
    Button,
    Modal,
    Popover
} from 'antd';

import {
    getLatestNotice, getNoticeByType
} from '../../../../request/api';
import moment from 'moment';

import {AddOperation, DownloadHelpOperation} from "../../../operation";
import {useTranslation} from "react-i18next";

const HelpDocument = () => {

    const { t, i18n } = useTranslation();

    //帮助文档弹框是否显示
    const [showDocumentModal, setShowDocumentModal] = useState(false);

    //语言切换时，关闭弹框
    useEffect(() => {
        if(i18n.language === 'zhCN') {
            setShowDocumentModal(false);
        }
    }, [i18n.language]);

    const helpDocumentClickHandler = () => {
        //中文 zhCN 英文 enUS 日文 jaJP
        if(i18n.language === 'zhCN') {
            downloadUserOperationPDF('TE-UM-V07 SmartOM3.0  操作说明（中文）.pdf')
        } else {
            setShowDocumentModal(true)
        }
    }

    const downloadUserOperationPDF = async (pdfName) => {
        try {
            // 将文件放在 public/statics/ 目录下
            const response = await fetch('/statics/' + pdfName);
            const blob = await response.blob();

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = pdfName;
            link.style.display = 'none';

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('下载失败:', error);
        }
    };

    return (
        <>
            <DownloadHelpOperation btnText={t('All.Operation.Download.downloadHelpDocs')} type='addPlant' onClick={helpDocumentClickHandler} />
            { /* 帮助文档 */
                <Modal
                    title={t('All.Operation.Download.downloadHelpDocs')}
                    closable={{'aria-label': 'Custom Close Button'}}
                    open={showDocumentModal}
                    className='ModalDefault'
                    onCancel={() => setShowDocumentModal(false)}
                    footer={null}
                    zIndex={10000}
                >
                    <div style={{padding: '20px'}}>
                        <div>
                            { 'TE-UM-V07 SmartOM3.0  操作マニュアル.pdf' }
                            {/* <DownloadHelpOperation btnText={t('All.Operation.Download.download')} type='addPlant' onClick={() => downloadUserOperationPDF('TE-UM-V07 SmartOM3.0  操作マニュアル.pdf')}/> */}
                            <Button
                                type='link'
                                onClick={() => downloadUserOperationPDF('TE-UM-V07 SmartOM3.0  操作マニュアル.pdf')}>
                                {t('All.Operation.Download.download')}
                            </Button>
                        </div>
                        <div>
                            { 'TE-UM-V07 SmartOM3.0  操作マニュアル（高圧蓄電所）.pdf' }
                            <Button
                                type='link'
                                onClick={() => downloadUserOperationPDF('TE-UM-V07 SmartOM3.0  操作マニュアル（高圧蓄電所）.pdf')}>
                                {t('All.Operation.Download.download')}
                            </Button>
                        </div>
                        <div>
                            { 'パスワード設定手順.pdf' }
                            <Button
                                type='link'
                                onClick={() => downloadUserOperationPDF('パスワード設定手順.pdf')}>
                                {t('All.Operation.Download.download')}
                            </Button>
                        </div>
                         <div>
                            { '260219 TAOKE ENERGY　製品セキュリティ脆弱性管理およびインシデント対応規程.pdf' }
                            <Button
                                type='link'
                                onClick={() => downloadUserOperationPDF('260219 TAOKE ENERGY　製品セキュリティ脆弱性管理およびインシデント対応規程.pdf')}>
                                {t('All.Operation.Download.download')}
                            </Button>
                        </div>
                         <div>
                            { 'PLCプログラムのダウンロード手順20250826.pdf' }
                            <Button
                                type='link'
                                onClick={() => downloadUserOperationPDF('PLCプログラムのダウンロード手順20250826.pdf')}>
                                {t('All.Operation.Download.download')}
                            </Button>
                        </div>
                         <div>
                            { 'PLC安全説明書.pdf' }
                            <Button
                                type='link'
                                onClick={() => downloadUserOperationPDF('PLC安全説明書.pdf')}>
                                {t('All.Operation.Download.download')}
                            </Button>
                        </div>
                        <div>
                            { 'ユーザデータ消去操作マニュアル.pdf' }
                            <Button
                                type='link'
                                onClick={() => downloadUserOperationPDF('ユーザデータ消去操作マニュアル.pdf')}>
                                {t('All.Operation.Download.download')}
                            </Button>
                        </div>
                         <div>
                            { '脆弱性情報開示ポリシー.pdf' }
                            <Button
                                type='link'
                                onClick={() => downloadUserOperationPDF('脆弱性情報開示ポリシー.pdf')}>
                                {t('All.Operation.Download.download')}
                            </Button>
                        </div>
                    </div>
                </Modal>
            }
        </>
    );
};

export default HelpDocument;
